// Used in avenue-assets.component.html

// Angular
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from "@angular/core";
import { FeathersServicePagination } from "@carnegie-learning/data-access-core";

// Services/Types/Helpers
import { Asset, PerformMedia } from "@carnegie-learning/cure-types";
import { PPUser as User } from "cli-types";

@Component({
    // Don't use onPush here, we want selectedAsset to render immediately when it changes.
    // changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "avenue-asset-list",
    templateUrl: "./avenue-asset-list.component.html",
    styleUrls: ["./avenue-asset-list.component.scss"],
    standalone: false
})
export class AvenueAssetListComponent implements OnChanges {
    assets: PerformMedia[] = [];
    @Input() assetsPagination?: FeathersServicePagination<Asset>;
    @Input() initSelectedAsset?: PerformMedia;

    @Input() profile?: User;
    @Input() updatedAssetMap?: Map<string, PerformMedia>;

    @Output() pagingEvent = new EventEmitter<number>();
    @Output() onSelectedAsset = new EventEmitter<PerformMedia>();
    @Output() editAssetEvent = new EventEmitter<PerformMedia>();
    @Output() deleteAssetEvent = new EventEmitter<PerformMedia>();

    selectedAsset?: PerformMedia;

    selectedAssetOnPage = false;
    loadingBool = true;

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.assetsPagination?.currentValue) {
            this.loadingBool = false;
            this.assets = <PerformMedia[]>(
                changes.assetsPagination.currentValue.data
            );
        } else {
            this.loadingBool = true;
        }
        this.setSelectedAsset();
    }


    setSelectedAsset() {
        if (this.initSelectedAsset) {
            this.selectedAsset = this.initSelectedAsset;
            this.assets = this.assets.filter(
                (a) => a.assetId !== this.selectedAsset?.assetId
            );
            this.assets.unshift(this.selectedAsset);
            this.onSelectAsset(this.initSelectedAsset);
            if (this.assetsPagination) {
                const data = this.assets;
                this.assetsPagination = {
                    ...this.assetsPagination,
                    data,
                };
            }
            this.loadingBool = false;
        }
    }

    hasData() {
        return !!this.assetsPagination?.data?.length;
    }

    canBeEdited(asset: PerformMedia) {
        if (!asset) {
            return false;
        }
        return (
            asset.publishedBy === this.profile?.userGUID ||
            this.profile?.roleLevel === 1
        );
    }

    showLoadMoreButton(): boolean {
        const assetsLength =
                this.assets?.filter((asset) => !asset.isDeleted).length || 0,
            assetPaginationLength = this.assetsPagination?.data?.length || 0,
            assetPaginationTotal = this.assetsPagination?.total || 0;
        return !!(assetsLength && assetPaginationLength < assetPaginationTotal);
    }

    loadMore() {
        this.pagingEvent.emit(20); // number of additional avenue assets to load
    }

    onSelectAsset(asset: PerformMedia) {
        this.selectedAssetOnPage = true;
        this.selectedAsset = asset;
        this.onSelectedAsset.emit(asset);
    }

    editAsset(asset: PerformMedia) {
        this.editAssetEvent.emit(asset);
    }

    deleteAsset(asset: PerformMedia) {
        this.deleteAssetEvent.emit(asset);
    }
}
